"use client";

import { useState } from "react";

const EXAMPLES = [
  { sport: "Snow", place: "Chamonix", score: 92, decision: "Go now", window: "09:00 to 11:00", detail: "Fresh snow and light winds. Check lift openings and the local avalanche bulletin before heading up." },
  { sport: "Surf", place: "Fistral", score: 82, decision: "Go later", window: "14:00 to 16:00", detail: "The wind eases this afternoon. Check the tide and local water safety before choosing your session." },
  { sport: "Wind", place: "Tarifa", score: 78, decision: "Go later", window: "13:00 to 15:00", detail: "A stronger afternoon breeze could suit a session. Check the launch, gusts and your ability before heading out." },
  { sport: "Bike", place: "Morzine", score: 74, decision: "Go now", window: "09:00 to 11:00", detail: "A dry morning window before showers arrive. Check trail openings and choose a route that suits your ability." },
] as const;

export function CompanionLandingPreview() {
  const [selected, setSelected] = useState(0);
  const example = EXAMPLES[selected];
  return (
    <div className="rounded-[22px] border border-white/10 bg-navy-light p-6 shadow-[0_40px_80px_-28px_rgba(0,0,0,.65)] md:p-[30px]">
      <div role="group" aria-label="Choose an example sport" className="mb-5 flex flex-wrap gap-2">
        {EXAMPLES.map((item, index) => (
          <button key={item.sport} type="button" aria-pressed={selected === index} onClick={() => setSelected(index)} className={`min-h-[44px] min-w-[44px] rounded-full border px-4 text-[13px] font-semibold ${selected === index ? "border-teal-light bg-teal text-white" : "border-white/30 text-white hover:bg-white/10"}`}>
            {item.sport}
          </button>
        ))}
      </div>
      <div aria-live="polite" aria-atomic="true">
        <p className="text-[12px] font-bold uppercase tracking-[0.12em] text-teal-light">Illustrative preview · {example.place}</p>
        <p className="mt-2 text-[14px] text-white/75">Example only, not a live forecast</p>
        <div className="my-6 flex items-end gap-4">
          <p className="font-serif text-[84px] leading-none text-teal-light md:text-[108px]">{example.score}</p>
          <div className="pb-2">
            <p className="text-[20px] font-semibold text-white">{example.decision}</p>
            <p className="mt-1 text-[14px] text-white/75">Score out of 100</p>
          </div>
        </div>
        <p className="font-semibold text-gold-light">{example.window} · local time</p>
        <p className="mt-4 text-[18px] leading-relaxed text-white/90">{example.detail}</p>
      </div>
    </div>
  );
}
